import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FloormapUiService } from '../../services/floormap-ui.service';
import { LocationModel } from '@kanzi-apes/kanzi-models';
import { FloormapContentComponent } from '../floormap-content';

@Component({
    selector: 'kanzi-floormap-viewer',
    templateUrl: './floormap-viewer.component.html',
    styleUrls: ['./floormap-viewer.component.scss'],
    standalone: false
})
export class FloormapViewerComponent implements OnInit, OnChanges {
  @Input() title: string = '';
  @Input() dataGroup: { object: any; type: string }[] = [];
  @Input() dataReport: {
    showRoomSelected: LocationModel;
    dataGroupFurniture: { object: any; type: string }[];
  } | null = null;
  @Input() locationSelected?: LocationModel;
  floorData?: { room_name: string };

  @ViewChild(FloormapContentComponent)
  floormapContentComponent!:FloormapContentComponent;
  
  constructor() {}

  ngOnInit(): void {}

  ngOnChanges() {
    if (this.dataReport && this.dataReport.showRoomSelected) {
      this.floorData = this.dataReport.showRoomSelected.params
        ? this.dataReport.showRoomSelected.params.data_floor
          ? this.dataReport.showRoomSelected.params.data_floor
          : null
        : null;
    }
  }

  clearLayout(){
    this.floormapContentComponent.clearLayout()
  }
}
